import { render } from "./KonvaTransformer.vue?vue&type=template&id=97273742"
import script from "./KonvaTransformer.vue?vue&type=script&lang=js"
export * from "./KonvaTransformer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__